<template>
	<!--<div>-->
		<!--<p class="text-center p-3 title-text"> {{fileName}} </p>-->
		<!--<div class="btn btn-danger btn-lg" v-on:click="deleteFile(  fileId )"><i class="fas fa-trash"></i></div>-->
		<!--</div>-->
		<form>
			<input v-bind:value="fileType"  ref="FileType"   type="hidden" class="">
			<div class="row pl-3 mt-2 mb-3">
				<div class="d-flex w-100 align-items-center mr-1" >
					<input v-bind:value="fileName"  ref="NewName"   type="text" v-bind:class="[showSaveBtn ? 'border-primary' : 'border-white']" class="form-control mr-2 h-100 py-3" v-on:focus="showSaveBtn = true">
					<button v-if="showSaveBtn" type="submit" v-on:click="renameFile(  fileId )" class="ml-0 mr-2 px-4 btn-lg btn-primary h-100"><i class="fas fa-save"></i></button>
				</div>

			</div>
		</form>
	</template>

	<script>
		export default {

			data() {
				return {
					showSaveBtn: false,
				}
			},
			props: [
			'fileId','fileName','fileType'
			],

			methods: {
				renameFile(fileId) {

					var newName = this.$refs.NewName.value;
					var FileType = this.$refs.FileType.value;


					console.log('fileId', fileId);

					const button = this.$refs.theInput;
					console.log(button);

					let formData = new FormData();
					formData.append('fileId', fileId);
					formData.append('fileName', newName +'.'+FileType);

					axios.post( '/manage/files/rename', formData )
					.then(function(data) {
						console.log(data);
						window.location.reload(true);
					}.bind(this)).catch(function(data) {

						console.log('error', data);
						alert('f');
					});


				},
			},


		}
	</script>


// WEBPACK FOOTER //
// resources/js/components/RenameFile.vue